export default "__VITE_ASSET__283639aa__"